import React from 'react';
import { t } from '@lingui/macro';
import { Heading, useBreakpoint } from '@landr/maestro';
import { RoutePaths } from 'types/enums';
import { Section } from 'components/Section/Section';
import FadeToApp from 'components/FadeToApp/FadeToApp';
import SearchProvider from 'controllers/SearchController/SearchContext';
import SearchQuery from 'controllers/SearchController/components/SearchQuery/SearchQuery';
import Filters from 'components/Filters/Filters';
import browseQueries from 'apollo/browse/browse';
import { useToLocalizedPath } from 'hooks/useToLocalizedPath/useToLocalizedPath';

const WistiaVideoId = '88waqs64p2';

const bgImage = 'heroGuest/hero-guest';
const bgFileType = 'png';
const bgPosition = 'centerCenter';
const dimensions = [768, 1280, '2x'];

export const _HeroSearch = ({
    wistiaVideoId,
    isMobile,
}: {
    wistiaVideoId: string;
    isMobile: boolean;
}) => {
    const toLocalizedPath = useToLocalizedPath();
    const heroHeading = t`Discover samples made for your music`;

    return (
        <>
            <Section boxed="md" minHeight="sixty">
                <Section.BackgroundVideo
                    wistiaVideoId={wistiaVideoId}
                    videoWidth={2689}
                    videoHeight={986}
                />
                <Section.BackgroundImage
                    image={bgImage}
                    filetype={bgFileType}
                    bgPosition={bgPosition}
                    dimensions={dimensions}
                    zoom={isMobile ? 2 : 1}
                />
                <Section.BackgroundOverlay>
                    <FadeToApp />
                </Section.BackgroundOverlay>
                <Section.Content contentPosition="center" py="mg">
                    <Heading as="h1" size={isMobile ? 'jb' : 'mg'} mb="xxl">
                        {heroHeading}
                    </Heading>
                    <SearchProvider
                        baseUrl={toLocalizedPath(`/${RoutePaths.Browse}`)}
                    >
                        <SearchQuery
                            samplesQueryConfig={browseQueries.samples}
                            packsQueryConfig={browseQueries.packs}
                        />
                        <Filters
                            defaultPlaceholder={t`Search instruments, genres, keyword...`}
                            withAdvancedFilters={false}
                        >
                            <Filters.SearchBar />
                        </Filters>
                    </SearchProvider>
                </Section.Content>
            </Section>
        </>
    );
};

const HeroSearch = () => {
    const isMobile = useBreakpoint('md');

    return <_HeroSearch wistiaVideoId={WistiaVideoId} isMobile={isMobile} />;
};

export default HeroSearch;
